import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { IAnswerSafetyNet } from '../../Models';
import { SafetyNetCardWidget } from './SafetyNetCardWidget';

interface IAnswersListWidgetProps {
    currentAnswerId: number | undefined;
    faqs: IAnswerSafetyNet[];
    opinionLabel: string;
    opinionVotedLabel: string;
    dictNoResultTitle: string;
    dictNoResultDescription: string;
    showNoResult: boolean;
    isLoading: boolean;
    dictYes: string;
    dictNo: string;
    dictCommentSuccess: string;
    dictCommentFail: string;
    dictSend: string;
    dictCommentInvite: string;
    dictYourComment: string;
    contactUrl: string;
    contactString: string;
    themeSubTitle: string | undefined;
}

interface IAnswersListWidgetState {
    currentOpenedAnswer?: IAnswerSafetyNet;
}

export class SafetyNetListWidget extends Component<
    IAnswersListWidgetProps,
    IAnswersListWidgetState
> {
    constructor(props: IAnswersListWidgetProps) {
        super(props);
        this.state = {
            currentOpenedAnswer: undefined,
        };
    }

    setCurrentAnswer = (answer?: IAnswerSafetyNet) => {
        if (answer === this.state.currentOpenedAnswer) {
            answer = undefined;
        }
        this.setState({ currentOpenedAnswer: answer });
    };

    render() {
        let currentAnswer: IAnswerSafetyNet | undefined;
        if (!this.state.currentOpenedAnswer && this.props.currentAnswerId) {
            currentAnswer = this.props.faqs.find(
                (f) => f.id === Number(this.props.currentAnswerId)
            );
        } else {
            currentAnswer = this.state.currentOpenedAnswer;
        }

        let answer: JSX.Element;
        if (this.props.faqs.length == 0 && this.props.showNoResult) {
            if (!this.props.isLoading) {
                answer = (
                    <div className="empty-state">
                        <i className="icon-no-results"></i>
                        <p>
                            <b>{this.props.dictNoResultTitle}</b>
                        </p>
                        <p>{this.props.dictNoResultDescription}</p>
                    </div>
                );
            } else {
                answer = <></>;
            }
        } else {
            answer = (
                <ul className="safetynet-faq">
                    {this.props.faqs.map((f) => {
                        if (f.showTitle) {
                            return (
                                <SafetyNetCardWidget
                                    key={f.id}
                                    faq={f}
                                    isOpen={f === currentAnswer}
                                    onClick={this.setCurrentAnswer}
                                    opinionLabel={this.props.opinionLabel}
                                    opinionVotedLabel={
                                        this.props.opinionVotedLabel
                                    }
                                    dictSend={this.props.dictSend}
                                    dictCommentSuccess={
                                        this.props.dictCommentSuccess
                                    }
                                    dictCommentFail={this.props.dictCommentFail}
                                    dictCommentInvite={
                                        this.props.dictCommentInvite
                                    }
                                    dictYourComment={this.props.dictYourComment}
                                    dictYes={this.props.dictYes}
                                    dictNo={this.props.dictNo}
                                    contactString={this.props.contactString}
                                    contactUrl={this.props.contactUrl}
                                />
                            );
                        } else {
                            return (
                                <li key={f.id}>
                                    <span
                                        className="text"
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                f.answer != undefined
                                                    ? f.answer
                                                    : '',
                                        }}
                                    />
                                    <span className="end-line"></span>
                                </li>
                            );
                        }
                    })}
                </ul>
            );
        }

        return (
            <div className="faq-bloc faq-bloc--page safetynet-faq ">
                {this.props.isLoading && (
                    <div className="lds-ripple">
                        <div></div>
                        <div></div>
                    </div>
                )}
                <h3
                    className="subtitle"
                    dangerouslySetInnerHTML={{
                        __html:
                            this.props.themeSubTitle != undefined
                                ? this.props.themeSubTitle
                                : '',
                    }}
                />
                {answer}
            </div>
        );
    }
}

WidgetHelper.register(SafetyNetListWidget, 'safety-net-list-widget');
